import { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { IonContent, IonModal } from '@ionic/react';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import { IPaymentGatewayConfig } from './InsuranceState';
import { PageHeader } from '../components/page/PageHeader';

const useStyles = createUseStyles(() => ({
    checkout: {
        border: 'none'
    }
}));

export const AutoRenewPaymentModal: React.FC<IPaymentGatewayConfig & {onClose: () => void}> = ({ client_secret, publishable_key, updateState, onClose }) => {
    const classes = useStyles();

    const [stripe, setStripe] = useState<any>();

    useEffect(() => {
        if (publishable_key) {
            setStripe(loadStripe(publishable_key));
        }
    }, [publishable_key]);

    const onComplete = () => {
        updateState();
        onClose();
    };

    return (
        <IonModal isOpen={Boolean(publishable_key)} onWillDismiss={onClose}>

            <PageHeader transparent onClose={onClose} />

            <IonContent>
                <EmbeddedCheckoutProvider key={client_secret} stripe={stripe} options={{ clientSecret: client_secret, onComplete }}>
                    <EmbeddedCheckout className={classes.checkout} />
                </EmbeddedCheckoutProvider>
            </IonContent>

        </IonModal>
    );
};
